import { AxiosInstance } from 'axios';
import { parseList } from './utils';
import { ContractsType, contractsPoints } from './types';

const getContractsData = (api: AxiosInstance) => ({
  getContracts: async (id: string): Promise<ContractsType> => {
    const { data } = await api.get(contractsPoints.GET_CONTRACTS, {
      params: { kid_ids: id },
    });
    return parseList(data.data);
  },
});

const assignContractData = (api: AxiosInstance) => ({
  assignContract: async (serial: string | number): Promise<void> => {
    const { data } = await api.post(
      `${contractsPoints.ASSIGN_CONTRACT}/${serial}`,
    );
    return data;
  },
});

const contractsService = (api: AxiosInstance) => {
  if (!api) throw new Error('There is no HTTP client');
  return {
    ...getContractsData(api),
    ...assignContractData(api),
  };
};
export default contractsService;



// WEBPACK FOOTER //
// ./src/services/contracts/contractsService.ts